export const selectTaskManagement = (state) => state.taskManagement


// WEBPACK FOOTER //
// ./web/js/taskManagement/selectors.js